import _ from 'lodash';
import axios from 'axios';

export class PriceChangeService {

  static async createPriceChangedOrders(ordersArray: any[]): Promise<any[]> {
    const updatedOrders: any[] = [];
    for(let i = 0; i < ordersArray.length; i++ ) {
      const order = ordersArray[i];
      let productPrice = _.get(order, 'productPrice');
      const priceChanged: boolean = String(productPrice._id).includes('new');
      if(priceChanged) {
        productPrice = await this.requestPriceChange(order.product, _.get(order,'productPrice.price'), _.get(order,'productPrice.minimumQuantity'))
      }
      updatedOrders.push({ ...order, productPrice });
    }
    return updatedOrders;
  }

  static async requestPriceChange(productId: number, requestedPrice: number, requestedMinQuantity: number): Promise<any> {
    try {
      const response = await axios.get(`/api/v2/product/${productId}/change-product-price`, {
        params: { price: requestedPrice, minimumQuantity: requestedMinQuantity }
      });
      return response.data['data'];
    } catch (error) {
      // eslint-disable-next-line
      console.error('error', error);
    }
  }

  static async approvePriceChange(ordersArray: any[]) {
    for(let i = 0; i < ordersArray.length; i++ ) {
      const order = ordersArray[i];
      const productPrice = _.get(order, 'productPrice');
      if(productPrice.status == 'Pending') {
        try {
          await axios.post(`/api/v2/product-price/${productPrice._id}/approve`, {});
        } catch (error) {
          // eslint-disable-next-line
          console.error('error', error);
        }
      }
    }
  }

}